import {
  Button,
  Col,
  EditButton,
  Form,
  getDefaultSortOrder,
  Icons,
  Input,
  List,
  Row,
  Space,
  Table,
  Tag,
  TextField,
  useTable
} from "@pankod/refine-antd";
import {
  CrudFilters,
  IResourceComponentsProps,
  useTranslate,
} from "@pankod/refine-core";
import { ButtonExport } from "components/buttonExport";
import useMediaScreen from "hooks/useMediaScreen";
import React from "react";
import { IGenre, IGenreResponse } from "types/genre.interface";
import { getOrderNumber } from "utils";

export const SlugList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { isMobile } = useMediaScreen();
  const { tableProps, sorter, searchFormProps }: any = useTable<IGenreResponse>(
    {
      resource: "genres",
      initialPageSize: 100,
      onSearch: (params) => {
        const filters: CrudFilters = [];
        const input = params;
        filters.push({
          field: "search",
          operator: "in",
          value: input,
        });
        return filters;
      },
    }
  );
  const current = tableProps?.pagination?.current;
  const pageSize = tableProps?.pagination?.pageSize;

  return (
    <List>
      <Row style={{ display: "block" }}>
         <div style={{ display: 'flex', gap: '5px', marginBottom: "5px" }}>
                    <TextField value='Total:' style={{ color: '#626262', fontSize: '14px', fontWeight: 700 }} />
                    <TextField value={tableProps?.pagination?.total} style={{ color: '#626262', fontSize: '14px', fontWeight: 700 }} />
        </div>
        <Col>
          <Form layout="vertical" {...searchFormProps}>
            <Form.Item
              label="Search"
              name="search"
              style={{ width: isMobile ? "100%" : "50%" }}
              initialValue=""
            >
              <Input
                placeholder="Name, Description, BgColor, Color"
                prefix={<Icons.SearchOutlined />}
              />
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  Filter
                </Button>
              </Form.Item>
              <ButtonExport path="genres" />
            </div>
          </Form>
        </Col>
        <Col>
          <Table
            {...tableProps}
            pagination={{
              ...tableProps?.pagination,
              showSizeChanger: true,
            }}
            rowKey="id"
          >
            <Table.Column
              dataIndex="_id"
              key="_id"
              title="Index"
              render={(value, item, index) => (
                <TextField value={getOrderNumber(current, pageSize, index)} />
              )}
            />
            <Table.Column
              dataIndex="name"
              key="name"
              title="Name"
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("name", sorter)}
              sorter
            />
            <Table.Column
              dataIndex="description"
              key="description"
              title="Description"
              render={(value) => <TextField value={value} />}
              defaultSortOrder={getDefaultSortOrder("description", sorter)}
              sorter
            />
            <Table.Column
              dataIndex="color"
              key="color"
              title="Color"
              render={(value) => <Tag color={value}>{value}</Tag>}
              defaultSortOrder={getDefaultSortOrder("color", sorter)}
              sorter
            />
            <Table.Column
              dataIndex="bgColor"
              key="bgColor"
              title="BgColor"
              render={(value) => <Tag color={value}>{value}</Tag>}
              defaultSortOrder={getDefaultSortOrder("bgColor", sorter)}
              sorter
            />
            <Table.Column<IGenre>
              title={t("table.actions")}
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  <EditButton hideText size="small" recordItemId={record._id} />
                  {/* <DeleteButton
                    hideText
                    size="small"
                    recordItemId={record._id}
                  /> */}
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </List>
  );
};
